/**
 * Formata uma string de data para DD-MM-AAAA.
 * Aceita formatos ISO (YYYY-MM-DD, YYYY-MM-DD HH:MM:SS, etc.)
 * Devolve "—" se o valor for nulo ou inválido.
 */
export function formatDate(valor) {
  if (!valor) return "—";
  // Pegar apenas os primeiros 10 caracteres (YYYY-MM-DD)
  const parte = String(valor).substring(0, 10);
  const [ano, mes, dia] = parte.split("-");
  if (!ano || !mes || !dia) return valor;
  return `${dia}-${mes}-${ano}`;
}
